import React from "react";
import './pagePayment.css'
import { CommandProps } from "../../components/types/types";
interface RecapPaymentProps {
    command: CommandProps[],
    isValid?:boolean,
}

const RecapPayment:React.FC<RecapPaymentProps> = ({command,isValid=true}) => {

    let amountHT = 0;
    let amountDiscount = 0;
    for(const elem of command) {
        amountHT += elem[1] * (elem[5] ? elem[5] : 1);
        amountDiscount += elem[3] ? elem[3] : 0;
    }

    const taxe = ((amountHT-amountDiscount)*0.2).toFixed(2);
    const totalHT = (amountHT-amountDiscount);
    const finalAmount = (totalHT*1.2).toFixed(2);

    return (
        <>
        <i className="midTextBold textRecapPayment" >Récapitulatif du paiement&nbsp;:</i>
        <div className="recapPayment smallText">
            
            {command.map((elem,id) => {
                return (<>
                    <div className="text" key={'descElemPayment'+id}><p style={{width:'70%'}}>{elem[0] || ''}</p><p>{(elem[1]*(elem[5] ? elem[5] : 1)).toFixed(2)} € HT</p></div>
                </>)
            })}
            <div className="separation"></div>
            <div className="text"><p>Total HT</p><p>{amountHT.toFixed(2)} €</p></div>
            {
                amountDiscount > 0 && <>
                    <div className="text"><p>Total remise</p><p>{amountDiscount.toFixed(2)} €</p></div>
                    <div className="text"><p>Total net HT</p><p>{totalHT.toFixed(2)} €</p></div>
                </>
            }
            <div className="text"><p>TVA 20%</p><p>{taxe}  €</p></div>
            <div className="separation"></div>
            <div className="smallTextBold text"><p>{isValid ? 'Solde net payé' : 'Solet net'}</p><p>{finalAmount} €</p></div>
        </div>
        </>
    )
}


export default RecapPayment